/**
 * Confirm password validation
 *
 * @param value
 * @param values
 * @returns {string}
 */
export function confirmPasswordValidation(value, values) {
    const { password } = values;
    return value === password ? '' : 'validation.error.confirmation_password';
}



// WEBPACK FOOTER //
// ./src/utils/confirmPasswordValidation.js